export default "__VITE_ASSET__2ed9a2e5__"